import React, {useEffect} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useRouter} from "next/router";
import {useModalRouting} from "../../utils/useModalRouting";
import {
  fetchEmails,
  reset,
  selectCurrentPage,
  selectError,
  selectIsLoading,
  selectEmails, setCurrentPage, selectIsLoadingMore
} from "../../redux/email/emailListSlice";
import {ApiError} from "../../errors/apiError";
import {RealmServiceError} from "../../errors/realmServiceError";
import {Container} from "../containers/Container";
import {StoreEmptyStateView} from "../storeFeed/StoreEmptyStateView";
import {WarningColorIcon} from "../icons";
import {HeroHeading2} from "../text";
import Link from "next/link";
import {Button} from "../buttons/Button";
import {EmailsTable} from "./EmailsTableView";

export const EmailsView: React.FC<any> = () => {
  const { t } = useTranslation()

  const dispatch = useAppDispatch()
  const router = useRouter()
  const { createRoute } = useModalRouting()

  const pageNumber = useAppSelector(selectCurrentPage)
  const emails = useAppSelector(selectEmails)
  const error = useAppSelector(selectError)
  const isLoading = useAppSelector(selectIsLoading)

  useEffect(() => {
    dispatch(reset())
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchEmails(pageNumber))
  }, [dispatch, pageNumber])

  const emptyStateButtonTitle = error instanceof ApiError && error.code === 'UNAUTHORIZED' || error instanceof RealmServiceError && error.code === 'NOT_LOGGED_IN'
    ? t('store:store_empty_state_button_go_back')
    : t('store:store_empty_state_button_try_again')

  return <Container>
    <div className={`${error ? '' : 'hidden'} flex-1 flex flex-col justify-center items-center`}>
      <StoreEmptyStateView
        onClick={() => {
          if (error instanceof ApiError && error.code === 'UNAUTHORIZED' || error instanceof RealmServiceError && error.code === 'NOT_LOGGED_IN') {
            router.back()
          } else {
            dispatch(reset())
            if (pageNumber === 1) {
              dispatch(fetchEmails(pageNumber))
            } else {
              dispatch(setCurrentPage(1))
            }
          }
        }}
        buttonTitle={emptyStateButtonTitle}
        error={error}
        icon={<WarningColorIcon />}
        isLoading={isLoading}
      />
    </div>

    <div className={`mb-8 ${error ? 'hidden' : ''} flex space-x-4`}>
      <HeroHeading2 className={`flex-grow`}>Emails</HeroHeading2>

      <div className="flex-shrink-0">
        <Link
          href={createRoute({ name: 'email_detail', query: { email_id: '' }, returnTo: '/admin/emails' })}
          shallow={true}
          passHref
        >
          <a>
            <Button
              buttonStyle="primary"
            >Create Email</Button>
          </a>
        </Link>
      </div>
    </div>

    <div className={`mb-8 ${error ? 'hidden' : ''}`}>
      <EmailsTable
        emails={emails}
        onLoadMoreClicked={() => {
          dispatch(setCurrentPage(pageNumber + 1))
        }}
      />
    </div>
  </Container>
}